export default __webpack_public_path__ + "static/media/i_home_active.b14c87a9.svg";